<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 card_bg">
				<search-bar :scrId="scrId" />
			</sf-card>
		</div>
		<div class="sf-col sf-col-20">
			<station-table :scrId="scrId" />
		</div>
		<station-registration-popup :scrId="scrId" />
	</div>
</template>

<script>
import SearchBar from './Search/SearchBar';
import StationTable from './Table/StationTable';
import StationRegistrationPopup from './Popup/StationRegistrationPopup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchBar,
		StationTable,
		StationRegistrationPopup
	}
};
</script>

<style></style>
